var _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 181,
    viewBox: "0 0 302 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 123.309,
    cy: 178.877,
    r: 65.2945,
    stroke: "white",
    strokeWidth: 1.16558
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 122.59,
    cy: 178.159,
    r: 33.5758,
    stroke: "white",
    strokeWidth: 1.16558
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 122.787,
    cy: 178.356,
    r: 106.773,
    stroke: "white",
    strokeWidth: 1.16558
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 122.996,
    cy: 178.564,
    r: 143.981,
    stroke: "white",
    strokeWidth: 1.16558
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 123.154,
    cy: 178.723,
    r: 178.14,
    stroke: "white",
    strokeWidth: 1.16558
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCircles);
export default __webpack_public_path__ + "static/media/contactCircles.4633a8cf58f32c72803960de2283f154.svg";
export { ForwardRef as ReactComponent };